export type TruthOrDareChoice =
  | "truth"
  | "dare";

export type ChoiceCardAction =
  | {
      readonly type:
        "CHOOSE";
      readonly choice:
        TruthOrDareChoice;
    }
  | {
      readonly type:
        "REVEAL";
    };

export function resolveChoiceCardAction(
  choice:
    TruthOrDareChoice,
  isAlreadySelected:
    boolean,
): ChoiceCardAction {
  if (
    isAlreadySelected
  ) {
    return {
      type:
        "REVEAL",
    };
  }

  return {
    type:
      "CHOOSE",
    choice,
  };
}
